import * as D from '../deps';

export function getDetails({ listenerId, pandoraId, sortingOrder = null }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.AESOP_GET_DETAILS,
    content: {
      pandoraId,
      listenerId,
      sortingOrder,
      catalogVersion: 4,
    },
    actionParams: {
      updateEntitiesWith: {
        pandoraId,
      },
    },
  });
}

export function getAllThumbedEpisodesByPodcastProgram({
  listenerId,
  pandoraId,
  isPositive,
  annotationLimit = 10,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.AESOP_GET_ALL_THUMBED_EPISODES_BY_PROGRAM,
    content: {
      pandoraId,
      listenerId,
      isPositive,
      annotationLimit,
      catalogVersion: 4,
    },
  });
}

export function getAllEpisodesByPodcastProgram({
  listenerId,
  pandoraId,
  annotationLimit = 0,
  sortingOrder = null,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.AESOP_GET_ALL_EPISODES_BY_PROGRAM,
    content: {
      pandoraId,
      listenerId,
      annotationLimit,
      catalogVersion: 4,
      sortingOrder,
    },
  });
}

export function removeEpisodesFeedback({ listenerId, episodeIds, pandoraId }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.AESOP_REMOVE_EPISODES_FEEDBACK,
    content: {
      listenerId,
      episodeIds,
      pandoraId,
      catalogVersion: 4,
    },
  });
}

export function annotateObjects({
  listenerId,
  pandoraIds,
  withProgress,
  ignoreAnnotations = false,
}) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.AESOP_ANNOTATE_OBJECTS,
    content: {
      pandoraIds,
      listenerId,
      withProgress,
      catalogVersion: 4,
    },
    actionParams: {
      ignoreAnnotations,
    },
  });
}
